import { algoliaApiSearch } from 'algolia-api/algoliaApiSearch';
import { AlgoliaApiListingResult } from 'algolia-api/listing/types/AlgoliaApiListingResult';
import { algoliaApiGetSearchConfig } from 'algolia-api/search/algoliaApiGetSearchConfig';
import getSearchLocationOptions from 'algolia-api/search/getSearchLocationOptions';
import { getVolopsSearchIndex } from 'algolia-api/search/getVolopsSearchIndex';
import { QueryOptions } from 'algolia-api/types/QueryOptions';
import { SearchLocation } from 'algolia-api/types/SearchLocation';
import { AreaOfFocus, VolopFunction } from 'utils/constants';

export async function algoliaApiGetRecommendedActions(
  searchLocation: Pick<SearchLocation, 'latitude' | 'longitude'>,
  queryOptions?: QueryOptions,
  options?: {
    volopFunction?: VolopFunction | null | undefined;
    areaOfFocus?: AreaOfFocus | null | undefined;
  },
) {
  const searchConfig = algoliaApiGetSearchConfig();
  let locationOptions = {};

  if (searchLocation?.latitude && searchLocation?.longitude) {
    locationOptions = getSearchLocationOptions(
      'auto',
      searchLocation,
    ).locationOptions;
  }

  const filters = [
    'type:VOLOP',
    'source:IDEALIST',
    options?.volopFunction && `(functions:'${options.volopFunction}')`,
    options?.areaOfFocus && `(areasOfFocus: '${options.areaOfFocus}')`,
  ]
    .filter(Boolean)
    .join(' AND ');

  const options2: QueryOptions = {
    index: getVolopsSearchIndex(),
    filters,
    hitsPerPage: 20,
    attributesToRetrieve: [
      'objectID',
      'name',
      'city',
      'state',
      'logo',
      'orgName',
      'url',
    ],
    ...locationOptions,
    ...queryOptions,
  };

  return algoliaApiSearch<AlgoliaApiListingResult>({
    config: searchConfig,
    query: '',
    queryOptions: options2,
  }).then(({ hits }) => hits);
}
